import { GridColDef } from "@mui/x-data-grid"

export const tempColumns: GridColDef[] = [
  {
    field: "status",
    headerName: "Qty Status",
  },
  {
    field: "purchase_order_number",
    headerName: "PO Number",
    width: 150,
    editable: false,
  },
  {
    field: "purchase_order_header_status",
    headerName: "PO Header Status",
    width: 150,
    editable: false,
  },
  {
    field: "line_number",
    headerName: "Line Number",
    width: 150,
    editable: false,
  },

  {
    field: "quantity",
    headerName: "Quantity",
    width: 150,
    editable: false,
  },
  {
    field: "amount",
    headerName: "Invoice Amount",
    width: 150,
    editable: false,
  },
  {
    field: "unit_price",
    headerName: "Unit Price",
    width: 150,
    editable: false,
  },
  {
    field: "line_status",
    headerName: "Line Status",
    width: 150,
    editable: false,
  },
  {
    field: "description",
    headerName: "Invoice Description",
    width: 150,
    editable: false,
  },
  {
    field: "item_description",
    headerName: "PO Description",
    width: 150,
    editable: false,
  },
  {
    field: "purchase_order_unit_price",
    headerName: "PO Unit Price",
    width: 150,
    editable: false,
  },
  {
    field: "unit",
    headerName: "Unit",
    width: 150,
    editable: false,
  },
  {
    field: "unit_measure_code",
    headerName: "UOM",
    width: 150,
    editable: false,
  },
  {
    field: "item_number",
    headerName: "Item Number",
    width: 150,
    editable: false,
  },
  {
    field: "quantity_billed",
    headerName: "Quantity Billed",
    width: 150,
    editable: false,
  },
  {
    field: "quantity_received",
    headerName: "Quantity Received",
    width: 150,
    editable: false,
  },
  {
    field: "amount_billed",
    headerName: "Amount Billed",
    width: 150,
    editable: false,
  },
  {
    field: "amount_received",
    headerName: "Amount Received",
    width: 150,
    editable: false,
  },
  {
    field: "matching_basis",
    headerName: "Matching Basis",
    width: 150,
    editable: false,
  },
  {
    field: "line_type",
    headerName: "Line Type",
    width: 150,
    editable: false,
  },
  {
    field: "distribution_code",
    headerName: "Distribution Code",
    width: 150,
    editable: false,
  },
  {
    field: "tax_amount",
    headerName: "Tax Amount",
    width: 150,
    editable: false,
  },
  {
    field: "tax_classification_code",
    headerName: "PO Tax Code",
    width: 150,
    editable: false,
  },
  {
    field: "shipment_quantity",
    headerName: "Shipment Quantity",
    width: 150,
    editable: false,
  },
  {
    field: "shipment_amount",
    headerName: "Shipment Amount",
    width: 150,
    editable: false,
  },
  {
    field: "shipment_number",
    headerName: "Shipment Number",
    width: 150,
    editable: false,
  },
  {
    field: "line_purchase_order_balance",
    headerName: "Line Purchase Order Balance",
    width: 150,
    editable: false,
  },
  {
    field: "purchase_order_supplier_name",
    headerName: "PO Supplier Name",
    width: 150,
    editable: false,
  },
]
